export enum VmpSelectionType {
  None = 0,
  AutoComplete = 1,
  Select = 2,
  ButtonEdit
}
